import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "data-testid"],
  _excluded2 = ["children"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { N500 } from '@atlaskit/theme/colors';
import { overrideStyleFunction } from '../../common/styles';
import { CustomItem } from '../Item';
var containerStyles = css({
  display: 'block',
  position: 'relative'
});

/**
 * __Container__
 *
 * A container for Header and Footer that safely handles props to the child component
 */
export var Container = function Container(_ref) {
  var children = _ref.children,
    testId = _ref['data-testid'],
    props = _objectWithoutProperties(_ref, _excluded);
  // https://stackoverflow.com/a/39333479
  var safeProps = function (_ref2) {
    var className = _ref2.className,
      onClick = _ref2.onClick,
      onMouseDown = _ref2.onMouseDown,
      onDragStart = _ref2.onDragStart,
      draggable = _ref2.draggable,
      ref = _ref2.ref,
      tabIndex = _ref2.tabIndex,
      disabled = _ref2.disabled;
    return {
      className: className,
      onClick: onClick,
      onMouseDown: onMouseDown,
      onDragStart: onDragStart,
      draggable: draggable,
      ref: ref,
      tabIndex: tabIndex,
      disabled: disabled
    };
  }(props);
  return jsx("div", _extends({
    "data-testid": testId,
    css: containerStyles
  }, safeProps), children);
};
/**
 * __Header__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */
var Header = /*#__PURE__*/forwardRef(function (props, ref) {
  var cssFn = overrideStyleFunction(function () {
    var _ref3;
    return _ref3 = {
      userSelect: 'auto'
    }, _defineProperty(_ref3, '[data-item-title]', {
      font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
      color: "var(--ds-text, ".concat(N500, ")")
    }), _defineProperty(_ref3, 'div&:hover', {
      backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
      cursor: 'default'
    }), _defineProperty(_ref3, 'div&:active', {
      backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
      color: "var(--ds-text, ".concat(N500, ")")
    }), _ref3;
  }, props.cssFn);
  return jsx(CustomItem, _extends({}, props, {
    ref: ref,
    component: props.component || Container
    // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
    ,
    cssFn: cssFn
    // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
    ,
    overrides: {
      Title: {
        render: function render(_, _ref4) {
          var children = _ref4.children,
            props = _objectWithoutProperties(_ref4, _excluded2);
          return jsx("h2", props, children);
        }
      }
    }
  }));
});
export default Header;